import React from 'react';
import styled from 'styled-components';

import { Breakpoints } from '../theme/Breakpoints';
import { Rounded } from '../theme/Rounded';
import { Spacing } from '../theme/Spacing';
import { Flex } from './Flex';
import { Text } from './Text';

const ContentWrapper = styled(Flex)`
  background-color: ${({ theme }) => theme.bgCanvas};
  border-radius: ${Rounded.lg};
  padding: ${Spacing.m};
  flex-direction: column;
  gap: ${Spacing.s};

  @media (min-width: ${Breakpoints.DESKTOP}) {
    gap: ${Spacing.m};
  }
`;

type SectionProps = {
  title: string;
  children: React.ReactNode;
  className?: string;
};

export const Section: React.FC<SectionProps> = ({
  title,
  children,
  className,
}) => {
  return (
    <Flex flexDirection="column" gap="s" className={className}>
      <Text fontWeight={'bold'}>{title}</Text>

      <ContentWrapper className="content-wrapper">{children}</ContentWrapper>
    </Flex>
  );
};
